import CommManager from "../../core/src/controllers/CommManager";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import HTMLPopupsManager from "../../core/src/utils/HTMLPopupsManager";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import ViewManager from "../../core/src/utils/ViewManager";
import UIController from "../../core/src/ui/UIController";
import GameModel from "../../core/src/model/GameModel";
import RelaxPOSTMessageController from '../../server/RelaxPOSTMessageController';
import BetModel from '../../core/src/model/BetModel';
import BuyFeatureModel from '../../core/src/model/BuyFeatureModel';
import { UpdateBetCommand } from '../../core/src/commands/GameCommands';
import SpinModel from '../../core/src/model/SpinModel';

export function RequestHistory(){
    CommandManager.execute(Commands.TOGGLE_SETTINGS);
    ViewManager.getLayer("SplashOverlay").setScene("open");
    CommManager.send(RequestRegister.get("historyRequest"), (data) => {
        ShowHistoryPage(data);
    }, this);
}

export function ShowHistoryPage(data){
    HTMLPopupsManager.showPopup("history",data);
}

export function HideHistoryPage(data){
    HTMLPopupsManager.closePopup("history");
}

export function CancelFreeSpins(){
    CommManager.send(RequestRegister.get("cancelFreeGames"), (data) => {
        // ShowHistoryPage(data);
    }, this);
}

export function SkipFreeSpins(){
    CommManager.send(RequestRegister.get("skipFreeGames"), (data) => {
        // ShowHistoryPage(data);
    }, this);
}
export function BuyFeatureSpin(){
    CommandManager.execute(Commands.SPIN);
    BuyFeatureModel.hasBuyFeatureIsTriggered = false;
    BuyFeatureModel.isInBuyFeatureFreeSpins = true;
}

export function SetBetCommand(coinSizeIndex: number) {
    console.log("[GameCommands] Set Bet Command: " + coinSizeIndex);
    BetModel.setStake(null, coinSizeIndex);
    SpinModel.update(BetModel.getCurrentBetStateData());
    UpdateBetCommand();
    RelaxPOSTMessageController.betUpdate(BetModel.totalBet)
  }


export function ShowErrorPopup(callback) {
    ViewManager.getLayer("SplashOverlay").setScene("open");
    UIController.toggleComponent("errorPopup", callback);
}
export function ShowBuyFeaturePopup(callback) {
    UIController.toggleComponent("buyFeature", callback);
}

export function GoHome() {
    if (GameModel.homeUrl) {
        if (GameModel.homeUrl === "close") {
            window.close();
        } else {
            RelaxPOSTMessageController.sendUserAction(GameModel.homeUrl);
        }
    } else {
        window.history.back();
    }
}

export function makeBalanceRequest() {
    CommManager.send(
        RequestRegister.get("getBalance"),
        (data) => {
            GameModel.shouldUpdateBalance = false;
            BetModel.balance = data.b;
        },
        this
    );
  }

export function OpenRCHistory() {
    if (GameModel.urlParams.rchistoryurl) {
        RelaxPOSTMessageController.sendUserAction(
            GameModel.urlParams.rchistoryurl
        );
    }
}
